import React from 'react';
import styles from '../css/styles.module.css'
import { app } from '../config/firebase.js';

export default function Header() {
    function onClick() {
        app.auth().signOut().catch((err) => {
            console.log(err);
        });
    }

    return (
        <div className={styles.header}>
            <h1 className={styles.highlight}>SDM</h1>
            <h1>Sales Report</h1>
            <button className={styles.logout} onClick={onClick}>Logout</button>
        </div>
    );
}